import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChooseEmployer from '../../common/ChooseEmployer';
import UserInfo from '../../../jobDetails/JobDetailsTab/UserInfo';
import NavButtons from '../NavButtons';
import EventSection from './EventSection';
import { jobCreationSteps } from '../../../../../constants/jobs';

export default class ChooseEmployerEventStep extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    employersPredictionsList: PropTypes.array.isRequired,
    userEventsList: PropTypes.array.isRequired,
    selectedEvent: PropTypes.object,
    searchEmployersAction: PropTypes.func.isRequired,
    clearEmployersPredictionsList: PropTypes.func.isRequired,
    chooseUser: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired,
    handleSelectEvent: PropTypes.func.isRequired,
    submitCreateEvent: PropTypes.func.isRequired
  };

  render () {
    const { user, employersPredictionsList, searchEmployersAction, clearEmployersPredictionsList, chooseUser,
      goToStep, handleSelectEvent, selectedEvent, userEventsList, submitCreateEvent } = this.props;
    const { photo_image_url, email, phone, is_company, company_logo_url, company_name, company_id, first_name, last_name } = user;
    return (
      <React.Fragment>
        { user.id ? (
          <React.Fragment>
            <div className='job-posting-section'>
              <UserInfo
                userId={user.id}
                userPhoto={photo_image_url}
                firstName={first_name}
                lastName={last_name}
                email={email}
                phone={phone}
                isCompany={is_company}
                companyLogoUrl={company_logo_url}
                companyName={company_name}
                companyId={company_id}
              />
            </div>
            <EventSection
              selectedEvent={selectedEvent}
              userEventsList={userEventsList}
              handleSelectEvent={handleSelectEvent}
              submitCreateEvent={submitCreateEvent}
            />
            <NavButtons
              showNextButton={!!user.id}
              goToStep={goToStep}
              nextStepId={jobCreationSteps.first.id}
            />
          </React.Fragment>
        ) : (
          <div className='job-posting-section'>
            <ChooseEmployer
              predictionsList={employersPredictionsList}
              searchAction={searchEmployersAction}
              submitUserSelect={chooseUser}
              clearEmployersPredictionsList={clearEmployersPredictionsList}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/ChooseEmployerEventStep/index.js